var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsSprite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrov_circle",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M4.45 9.333c2.305-3.985 6.614-6.667 11.55-6.667 7.364 0 13.333 5.97 13.333 13.333s-5.97 13.333-13.333 13.333c-4.935 0-9.244-2.681-11.55-6.667"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M16 21.333l5.333-5.333-5.333-5.333"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M2.667 16h18.667"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-bell",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3,
    d: "M12.472 28c0.94 0.83 2.175 1.333 3.528 1.333s2.588-0.504 3.528-1.333M24 10.667c0-2.122-0.843-4.157-2.343-5.657s-3.535-2.343-5.657-2.343-4.157 0.843-5.657 2.343c-1.5 1.5-2.343 3.535-2.343 5.657 0 4.12-1.039 6.941-2.2 8.807-0.979 1.574-1.469 2.361-1.451 2.58 0.020 0.243 0.071 0.336 0.267 0.481 0.177 0.131 0.974 0.131 2.569 0.131h17.63c1.595 0 2.392 0 2.569-0.131 0.196-0.145 0.247-0.238 0.267-0.481 0.018-0.22-0.472-1.006-1.451-2.58-1.161-1.866-2.2-4.687-2.2-8.807z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-colors",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 27.296c1.415 1.267 3.284 2.037 5.333 2.037 4.418 0 8-3.582 8-8 0-3.689-2.497-6.795-5.893-7.72M8.56 13.614c-3.396 0.925-5.894 4.031-5.894 7.72 0 4.418 3.582 8 8 8s8-3.582 8-8c0-1.041-0.199-2.035-0.56-2.947M24 10.667c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8c4.418 0 8 3.582 8 8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-container",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M27.333 9.704l-11.333 6.296M16 16l-11.333-6.296M16 16l0 12.667M28 21.411v-10.823c0-0.457 0-0.685-0.067-0.889-0.060-0.18-0.157-0.346-0.285-0.485-0.145-0.158-0.345-0.269-0.744-0.491l-9.867-5.481c-0.378-0.21-0.567-0.315-0.767-0.356-0.177-0.036-0.36-0.036-0.537 0-0.2 0.041-0.389 0.146-0.767 0.356l-9.867 5.481c-0.399 0.222-0.599 0.333-0.744 0.491-0.129 0.14-0.226 0.305-0.286 0.485-0.067 0.204-0.067 0.432-0.067 0.889v10.823c0 0.457 0 0.685 0.067 0.889 0.060 0.18 0.157 0.346 0.286 0.485 0.145 0.158 0.345 0.269 0.744 0.491l9.867 5.482c0.378 0.21 0.567 0.315 0.767 0.356 0.177 0.036 0.36 0.036 0.537 0 0.2-0.041 0.389-0.146 0.767-0.356l9.867-5.482c0.399-0.222 0.599-0.333 0.744-0.491 0.129-0.14 0.226-0.305 0.285-0.485 0.067-0.204 0.067-0.432 0.067-0.889z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-filter",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3,
    d: "M29.334 4h-26.667l10.667 12.613v8.72l5.333 2.667v-11.387l10.667-12.613z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-hexagon",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M14.964 3.242c0.378-0.21 0.567-0.315 0.767-0.356 0.177-0.036 0.36-0.036 0.537 0 0.2 0.041 0.389 0.146 0.767 0.356l9.867 5.482c0.399 0.222 0.599 0.333 0.744 0.491 0.129 0.14 0.226 0.305 0.285 0.485 0.067 0.204 0.067 0.432 0.067 0.889v10.823c0 0.457 0 0.685-0.067 0.889-0.060 0.18-0.157 0.346-0.285 0.485-0.145 0.158-0.345 0.269-0.744 0.491l-9.867 5.482c-0.378 0.21-0.567 0.315-0.767 0.356-0.177 0.036-0.36 0.036-0.537 0-0.2-0.041-0.389-0.146-0.767-0.356l-9.867-5.482c-0.399-0.222-0.599-0.333-0.744-0.491-0.129-0.14-0.226-0.305-0.286-0.485-0.067-0.204-0.067-0.432-0.067-0.889v-10.823c0-0.457 0-0.685 0.067-0.889 0.060-0.18 0.157-0.346 0.286-0.485 0.145-0.158 0.345-0.269 0.744-0.491l9.867-5.481z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-lightning",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M18.999 2.667h-7.674c-0.239 0-0.359 0-0.465 0.036-0.093 0.032-0.178 0.085-0.249 0.154-0.080 0.078-0.133 0.185-0.24 0.399l-5.6 11.2c-0.256 0.511-0.383 0.767-0.353 0.974 0.027 0.181 0.127 0.344 0.277 0.449 0.172 0.12 0.458 0.12 1.029 0.12h8.274l-4 13.333 16.258-16.86c0.548-0.569 0.823-0.853 0.839-1.097 0.014-0.211-0.073-0.417-0.235-0.553-0.186-0.157-0.581-0.157-1.372-0.157h-9.49l3-8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-loading",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M4.454 22.666c-1.67-2.893-0.821-6.58 1.944-8.453l0.003-0.003c2.221-1.501 5.143-1.45 7.312 0.126l4.576 3.327c2.167 1.576 5.090 1.627 7.312 0.126l0.003-0.003c2.766-1.872 3.616-5.563 1.943-8.453M22.669 27.546c-2.893 1.669-6.58 0.821-8.453-1.944l-0.003-0.003c-1.501-2.221-1.45-5.143 0.126-7.312l3.327-4.576c1.576-2.167 1.627-5.090 0.126-7.312l-0.006-0.003c-1.872-2.763-5.563-3.615-8.453-1.942M25.427 6.572c5.207 5.207 5.207 13.648 0 18.855s-13.648 5.207-18.855 0c-5.207-5.207-5.207-13.648 0-18.855s13.648-5.207 18.855 0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-login",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8667 10.0798C12.28 5.27982 14.7467 3.31982 20.1467 3.31982H20.32C26.28 3.31982 28.6667 5.70649 28.6667 11.6665V20.3598C28.6667 26.3198 26.28 28.7065 20.32 28.7065H20.1467C14.7867 28.7065 12.32 26.7732 11.88 22.0532",
    stroke: "#BEDBB0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 16H19.8398",
    stroke: "#BEDBB0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8667 11.5332L21.3334 15.9999L16.8667 20.4665",
    stroke: "#BEDBB0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3314 23.0269C13.5759 21.7553 13.7841 20.4168 14.0783 19.0782C14.2232 18.3777 14.0466 18.0788 13.2635 18.1324C12.4804 18.1859 11.6068 18.1591 10.7739 18.1324C9.94105 18.1056 9.79167 17.6862 10.2715 17.0883C12.6343 14.1703 15.0243 11.2881 17.4053 8.41472C17.6724 8.08902 17.9802 7.85701 18.4193 8.1024C18.8583 8.3478 18.7678 8.6512 18.6954 9.01706C18.4328 10.3556 18.2156 11.6941 17.9259 13.0058C17.7765 13.684 17.9711 13.9249 18.6773 13.8982C19.386 13.8625 20.096 13.8625 20.8047 13.8982C21.2076 13.8982 21.7372 13.6885 21.9454 14.2373C22.1536 14.7861 21.7146 15.0181 21.4928 15.3438C20.5875 16.4592 19.6701 17.5731 18.7406 18.6856C17.3797 20.3097 16.0292 21.9278 14.6894 23.54C14.4268 23.8567 14.1326 24.1111 13.6845 23.9504C13.2364 23.7898 13.3314 23.4106 13.3314 23.0269Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pencil",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M3.333 28.667l7.399-2.846c0.473-0.182 0.71-0.273 0.931-0.392 0.197-0.106 0.384-0.227 0.56-0.364 0.199-0.154 0.378-0.333 0.736-0.692l15.040-15.040c1.473-1.473 1.473-3.861 0-5.333s-3.861-1.473-5.333 0l-15.040 15.040c-0.359 0.359-0.538 0.538-0.692 0.736-0.137 0.176-0.259 0.364-0.364 0.56-0.119 0.221-0.21 0.458-0.392 0.931l-2.846 7.399zM3.333 28.667l2.744-7.135c0.196-0.511 0.295-0.766 0.463-0.883 0.147-0.102 0.329-0.141 0.505-0.107 0.201 0.038 0.395 0.232 0.782 0.619l3.012 3.012c0.387 0.387 0.58 0.58 0.619 0.782 0.034 0.176-0.005 0.358-0.107 0.505-0.117 0.168-0.372 0.267-0.883 0.463l-7.135 2.744z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.2857,
    d: "M16 6.667v18.667"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.2857,
    d: "M6.666 16h18.667"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-project",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M4.396 6.978c0.301-1.281 1.301-2.282 2.582-2.582v0c1.11-0.26 2.266-0.26 3.377 0v0c1.281 0.301 2.282 1.301 2.582 2.582v0c0.26 1.11 0.26 2.266 0 3.377v0c-0.301 1.281-1.301 2.282-2.582 2.582v0c-1.11 0.26-2.266 0.26-3.377 0v0c-1.281-0.301-2.282-1.301-2.582-2.582v0c-0.26-1.11-0.26-2.266 0-3.377v0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M4.396 21.645c0.301-1.281 1.301-2.282 2.582-2.582v0c1.11-0.261 2.266-0.261 3.377 0v0c1.281 0.3 2.282 1.301 2.582 2.582v0c0.26 1.111 0.26 2.266 0 3.377v0c-0.301 1.281-1.301 2.282-2.582 2.582v0c-1.11 0.261-2.266 0.261-3.377 0v0c-1.281-0.3-2.282-1.301-2.582-2.582v0c-0.26-1.111-0.26-2.266 0-3.377v0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M19.063 6.978c0.3-1.281 1.301-2.282 2.582-2.582v0c1.111-0.26 2.266-0.26 3.377 0v0c1.281 0.301 2.282 1.301 2.582 2.582v0c0.261 1.11 0.261 2.266 0 3.377v0c-0.3 1.281-1.301 2.282-2.582 2.582v0c-1.111 0.26-2.266 0.26-3.377 0v0c-1.281-0.301-2.282-1.301-2.582-2.582v0c-0.261-1.11-0.261-2.266 0-3.377v0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M19.063 21.645c0.3-1.281 1.301-2.282 2.582-2.582v0c1.111-0.261 2.266-0.261 3.377 0v0c1.281 0.3 2.282 1.301 2.582 2.582v0c0.261 1.111 0.261 2.266 0 3.377v0c-0.3 1.281-1.301 2.282-2.582 2.582v0c-1.111 0.261-2.266 0.261-3.377 0v0c-1.281-0.3-2.282-1.301-2.582-2.582v0c-0.261-1.111-0.261-2.266 0-3.377v0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-puzzle",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 2.667l4.8 4.8c3.2-8.4 12.133 0.533 3.733 3.733l4.8 4.8-4.8 4.8c-3.2-8.4-12.133 0.533-3.733 3.733l-4.8 4.8-4.8-4.8c-3.2 8.4-12.133-0.533-3.733-3.733l-4.8-4.8 4.8-4.8c3.2 8.4 12.133-0.533 3.733-3.733l4.8-4.8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-star",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 2.667l2.683 6.975c0.376 0.978 0.564 1.466 0.856 1.878 0.259 0.364 0.577 0.683 0.942 0.942 0.411 0.292 0.9 0.48 1.878 0.856l6.975 2.683-6.975 2.683c-0.978 0.376-1.466 0.564-1.878 0.856-0.364 0.259-0.683 0.577-0.942 0.942-0.292 0.411-0.48 0.9-0.856 1.878l-2.683 6.975-2.683-6.975c-0.376-0.978-0.564-1.466-0.856-1.878-0.259-0.364-0.578-0.683-0.942-0.942-0.411-0.292-0.9-0.48-1.878-0.856l-6.975-2.683 6.975-2.683c0.978-0.376 1.466-0.564 1.878-0.856 0.364-0.259 0.683-0.578 0.942-0.942 0.292-0.411 0.48-0.9 0.856-1.878l2.683-6.975z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M12 4h8"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M4 8h24"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M6.667 8l0.801 12.018c0.149 2.231 0.223 3.347 0.588 4.243 0.662 1.627 2.004 2.883 3.672 3.435 0.919 0.304 2.037 0.304 4.273 0.304v0c2.236 0 3.354 0 4.273-0.304 1.668-0.552 3.010-1.808 3.672-3.435 0.365-0.896 0.439-2.012 0.588-4.243l0.801-12.018"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-eye",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.3111,
    d: "M1.333 16c0 0 5.333-10.667 14.667-10.667s14.667 10.667 14.667 10.667c0 0-5.333 10.667-14.667 10.667s-14.667-10.667-14.667-10.667z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.3111,
    d: "M16 20c2.209 0 4-1.791 4-4s-1.791-4-4-4c-2.209 0-4 1.791-4 4s1.791 4 4 4z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M24 8l-16 16"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M8 8l16 16"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-help-circle",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_1264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 18.3334C14.6022 18.3334 18.3332 14.6024 18.3332 10C18.3332 5.39765 14.6022 1.66669 9.99984 1.66669C5.39746 1.66669 1.6665 5.39765 1.6665 10C1.6665 14.6024 5.39746 18.3334 9.99984 18.3334Z",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5752 7.49999C7.77112 6.94304 8.15782 6.47341 8.66682 6.17426C9.17583 5.87512 9.77428 5.76577 10.3562 5.86558C10.9381 5.96539 11.4659 6.26792 11.8461 6.71959C12.2263 7.17126 12.4344 7.74292 12.4335 8.33332C12.4335 9.99999 9.93353 10.8333 9.93353 10.8333",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14.1667H10.0125",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_1264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-vector",
    viewBox: "0 0 41 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.9714,
    d: "M1.714 16s6.857-13.714 18.857-13.714 18.857 13.714 18.857 13.714-6.857 13.714-18.857 13.714-18.857-13.714-18.857-13.714z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user_default",
    viewBox: "0 0 37 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.445 7.556c0 4.173-3.383 7.556-7.556 7.556s-7.556-3.383-7.556-7.556c0-4.173 3.383-7.556 7.556-7.556s7.556 3.383 7.556 7.556z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.169 33.208c0-2.441-0.481-4.857-1.415-7.112s-2.303-4.303-4.029-6.029c-1.726-1.726-3.774-3.095-6.029-4.029s-4.671-1.415-7.112-1.415c-2.44 0-4.857 0.481-7.112 1.415s-4.303 2.303-6.029 4.029c-1.726 1.726-3.095 3.774-4.029 6.029s-1.415 4.671-1.415 7.112h37.169z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M4 16h24"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M4 8h24"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M4 24h24"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-vector-logo",
    viewBox: "0 0 24 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.663 30.054c0.489-2.543 0.905-5.22 1.494-7.897 0.29-1.401-0.063-1.999-1.63-1.892s-3.313 0.053-4.979 0c-1.666-0.054-1.965-0.892-1.005-2.088 4.726-5.836 9.506-11.6 14.268-17.347 0.534-0.651 1.15-1.115 2.028-0.625s0.697 1.098 0.552 1.829c-0.525 2.677-0.96 5.354-1.539 7.978-0.299 1.356 0.091 1.838 1.503 1.785 1.417-0.071 2.837-0.071 4.255 0 0.806 0 1.865-0.419 2.281 0.678s-0.462 1.562-0.905 2.213c-1.811 2.231-3.645 4.459-5.504 6.684-2.722 3.248-5.423 6.484-8.102 9.709-0.525 0.633-1.114 1.142-2.010 0.821s-0.706-1.080-0.706-1.847z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.2857,
    d: "M16 6.667v18.667"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.2857,
    d: "M6.666 16h18.667"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSprite);
export default __webpack_public_path__ + "static/media/iconsSprite.3d1e8d9efafaaa16c381376cff0ad9c6.svg";
export { ForwardRef as ReactComponent };